import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';

const Toggle = ({ toggleValue, toggleObject }) => {
  const handleToggleChange = (event, value) => {
    if (value !== null) {
      toggleValue(value); // update parent state
    }
  };

  return (
    <div className="toggleButtonContainer">
      <ToggleButtonGroup
        color="primary"
        value={toggleObject.tableSelection} // controlled by parent
        exclusive
        onChange={handleToggleChange}
        aria-label="Platform"
      >
        {toggleObject.toggleButtons.map((toggleItem, index) => (
          <ToggleButton key={index} value={toggleItem}>
            {toggleItem}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default Toggle;